import * as React from 'react';
import { memo } from 'react';

const ExceptionalProperties = () => (
  <svg
    width="32"
    height="20"
    viewBox="0 0 32 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.2185 3.98234V1.52216C16.2185 0.850945 15.5704 0.370317 14.9281 0.565263L1.7834 4.55499C1.36197 4.6829 1.07384 5.07147 1.07384 5.51188V15.5837H10.5625M16.2185 3.98234L14.5309 3.44873M16.2185 3.98234L30.0604 7.9342C30.4898 8.0568 30.7859 8.44923 30.7859 8.89578V15.5837H14.5309M13.8647 3.2381L14.5309 3.44873M14.5309 3.44873V15.5837M14.5309 15.5837H13.3761M20.1268 13.0008H16.2185V10.2865H20.1268M20.1268 13.0008V10.2865M20.1268 13.0008H24.5237M20.1268 10.2865H24.5237M24.5237 10.2865H28.9205V13.0008H24.5237M24.5237 10.2865V13.0008M10.5625 15.5837V10.2865H13.3761V15.5837M10.5625 15.5837H13.3761M7.78014 6.08372H13.3761V8.97312H7.78014M7.78014 6.08372H2.18416V8.97312H7.78014M7.78014 6.08372V8.97312M4.84891 16.8902L0.274414 19.1736H31.2744L26.8332 16.8902H4.84891Z"
      stroke="white"
    />
  </svg>
);

const Memo = memo(ExceptionalProperties);
export default Memo;
